export default "__VITE_ASSET__gw5Vb$ca__"